<template>
  <div class="scenario_info">
<!--    <span>Client: {{client}}</span>-->
    <span v-if="campaignId && campaignId!=='0'">Campaign ID: {{campaignId}}</span>
    <span v-if="scenarioId">Scenario ID: {{scenarioId}}</span>
<!--    <span>Audio root: {{audioRoot}}</span>-->
<!--    <span>Redirect root: {{redirectRoot}}</span>-->
  </div>
</template>

<script>
    export default {
      name: 'ScenarioInfo',
      props: ['campaignId', 'scenarioId'],
      data() {
        return {
          audioRoot: 'http://voicebot.ivoice.online' + '/' + (this._props.client || ''),
          redirectRoot: 'sofia/gateway/' + (this._props.client || '')
        }
      }
    }
</script>

<style scoped>
  span {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// ScenarioInfo.vue?9420fb20